<div
  data-slot="empty-icon"
  [attr.data-variant]="variant"
  [ngClass]="mediaClasses"
>
  <ng-content></ng-content>
</div>
